<template>
  <div v-if="!finishVolonter" class="volonter">
    <h4>1. Unesite ime i prezime</h4>
    <InputText type="text" v-model="firstAndLastName" />

    <h4>2. Pol</h4>
    <Dropdown
      v-model="gender"
      :options="genders"
      placeholder="Izaberite"
      class="dropdown"
    />
    <h4>3. Datum rođenja</h4>
    <Calendar
      v-model="dateOfBirth"
      showIcon
      inputId="buttondisplay"
      :dateFormat="dateFormat"
      placeholder="dd/mm/yyyy"
      class="calendar"
      :manualInput="false"
      showButtonBar
      :yearNavigator="true"
      :yearRange="`1930:${new Date().getFullYear()}`"
      :maxDate="new Date()"
    />

    <h4>4. Mjesto rođenja</h4>
    <LocationSelect
      v-model:country="countryPlaceOfBirth"
      v-model:city="cityPlaceOfBirth"
      countryPlaceholder="Država"
      cityPlaceholder="Grad"
    />

    <h4>5. Adresa prebivališta</h4>
    <InputText
      type="text"
      placeholder="Ulica i broj"
      class="inline-input"
      v-model="streetAndNumber"
    />
    <InputText
      type="text"
      placeholder="Poštanski fah"
      class="inline-input"
      v-model="postCode"
    />
    <LocationSelect
      v-model:country="stateAddressInfo"
      v-model:city="cityAddressInfo"
    />

    <h4>6. Kontakt podaci</h4>
    <PhoneInput v-model="mobilePhone" placeholder="Broj mobilnog telefona" class="inline-input" />
    <InputText
      type="text"
      placeholder="E-mail adresa"
      class="inline-input"
      v-model="email"
    />
    <PhoneInput v-model="viber" placeholder="Viber" class="inline-input" />
    <PhoneInput v-model="homePhoneNumber" placeholder="Broj fiksnog telefona" class="inline-input" />
    <PhoneInput v-model="whatsapp" placeholder="WhatsApp" class="inline-input" />
    <PhoneInput v-model="signal" placeholder="Signal" class="inline-input" />
    <PhoneInput v-model="telegram" placeholder="Telegram" class="inline-input" />

    <InputText
      type="text"
      placeholder="Facebook Messenger"
      class="inline-input"
      v-model="facebook"
    />

    <h4>7. Školska sprema</h4>
    <Dropdown
      v-model="educationalBackground"
      :options="educational"
      placeholder="Izaberite"
      class="dropdown"
    />

    <h4>8. Zanimanje</h4>
    <InputText
      type="text"
      placeholder="Unesite Vaše zanimanje"
      v-model="profession"
    />

    <h4>9. Radni status</h4>
    <Dropdown
      v-model="workStatus"
      :options="status"
      placeholder="Izaberite"
      class="dropdown"
    />

    <h4>
      10. Da li ste zainteresovani da saznate nešto više o pravima osoba s
      invaliditetom?
    </h4>

    <div class="button-container">
      <div class="checkbox-label">
        <RadioButton
          name="learnAboutOsi"
          value="Da"
          inputId="yes"
          v-model="learnAboutOsi"
        />
        <label for="yes" class="label">Da</label>
        <RadioButton
          name="learnAboutOsi"
          value="Ne"
          inputId="no"
          v-model="learnAboutOsi"
        />
        <label for="no" class="label">Ne</label>

        <RadioButton
          name="learnAboutOsi"
          value="Ne znam"
          inputId="unknown"
          v-model="learnAboutOsi"
        />
        <label for="unknown" class="label">Ne znam</label>
      </div>
    </div>

    <h4>
      11. Da li ste zainteresovani da se uključite u neposredno pružanje podrške
      osobama s invaliditetom?
    </h4>

    <div class="button-container">
      <div class="checkbox-label">
        <RadioButton
          name="choice2"
          value="Da"
          inputId="yes2"
          v-model="supportForOsiQuestion"
        />
        <label for="yes2" class="label">Da</label>
        <RadioButton
          name="choice2"
          value="Ne"
          inputId="no2"
          v-model="supportForOsiQuestion"
        />
        <label for="no2" class="label">Ne</label>

        <RadioButton
          name="choice2"
          value="Ne znam"
          inputId="unknown2"
          v-model="supportForOsiQuestion"
        />
        <label for="unknown2" class="label">Ne znam</label>
      </div>
    </div>
    <div v-if="supportForOsiQuestion === 'Da'">
      <h4>
        11.1 Koji vid neposredne podrške biste pružali osobama s invaliditetom?
      </h4>
      <Textarea v-model="supportForOsi" autoResize rows="3" cols="47" />
    </div>

    <h4>12. Da li govorite neki od stranih jezika?</h4>
    <div class="button-container">
      <div class="checkbox-label">
        <RadioButton
          name="choice3"
          value="Da"
          inputId="yes3"
          v-model="foreignLanguagesQuestion"
        />
        <label for="yes3" class="label">Da</label>
        <RadioButton
          name="choice3"
          value="Ne"
          inputId="no3"
          v-model="foreignLanguagesQuestion"
        />
        <label for="no3" class="label">Ne</label>
      </div>
    </div>
    <div v-if="foreignLanguagesQuestion === 'Da'" class="inputFields">
      <h4>12.1 Koji strani/e jezik/e govorite?</h4>
      <InputText type="text" v-model="foreignLanguages" />
    </div>

    <div v-if="foreignLanguagesQuestion === 'Ne'">
      <h4>12.1 Da li biste željeli da naučite neki strani jezik?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="foreignLanguagesNo"
            value="Da"
            inputId="yes33"
            v-model="foreignLanguagesNo"
          />
          <label for="yes33" class="label">Da</label>

          <RadioButton
            name="foreignLanguagesNo"
            value="Ne"
            inputId="no33"
            v-model="foreignLanguagesNo"
          />
          <label for="no33" class="label">Ne</label>

          <RadioButton
            name="foreignLanguagesNo"
            value="Ne znam"
            inputId="unknown33"
            v-model="foreignLanguagesNo"
          />
          <label for="unknown33" class="label">Ne znam</label>
        </div>
      </div>
    </div>

    <h4>13. Da li poznajete rad na računaru?</h4>
    <div class="button-container">
      <div class="checkbox-label">
        <RadioButton
          name="choice4"
          value="Da"
          inputId="yes4"
          v-model="computerDetailsFirstQuestion"
        />
        <label for="yes4" class="label">Da</label>
        <RadioButton
          name="choice4"
          value="Ne"
          inputId="no4"
          v-model="computerDetailsFirstQuestion"
        />
        <label for="no4" class="label">Ne</label>
      </div>
    </div>
    <div v-if="computerDetailsFirstQuestion === 'Ne'">
      <h4>13.1 Da li biste željeli da naučite?</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="choice5"
            value="Da"
            inputId="yes5"
            v-model="computerDetailsSecondQuestion"
          />
          <label for="yes5" class="label">Da</label>
          <RadioButton
            name="choice5"
            value="Ne"
            inputId="no5"
            v-model="computerDetailsSecondQuestion"
          />
          <label for="no5" class="label">Ne</label>
        </div>
      </div>
    </div>
    <h4>
      14. Zainteresovan/a sam za učešće na: <br />Možete izabrati više odgovora
    </h4>
    <div class="relative">
      <MultiSelect
        v-model="selectedInterests"
        display="chip"
        :options="interests"
        optionLabel="period"
        placeholder="Izaberite"
        :maxSelectedLabels="20"
        appendTo="body"
        :panelStyle="{ maxWidth: 'calc(100vw - 40px)', overflowX: 'hidden' }"
      />
    </div>
    <div v-if="hasOtherInterest">
      <InputText
        type="text"
        v-model="otherInterest"
        placeholder="Ostalo – navedite"
        aria-label="Ostalo – navedite"
      />
    </div>

    <h4>
      15. Da li ste zainteresovani da učestvujete u kreiranju usluga i politika
      koje doprinose poboljšanju uslova života osoba s invaliditetom u Crnoj
      Gori?
    </h4>

    <div class="button-container">
      <div class="checkbox-label">
        <RadioButton
          name="choice6"
          value="Da"
          inputId="yes6"
          v-model="interestedInCreatingServices"
        />
        <label for="yes6" class="label">Da</label>
        <RadioButton
          name="choice6"
          value="Ne"
          inputId="no6"
          v-model="interestedInCreatingServices"
        />
        <label for="no6" class="label">Ne</label>

        <RadioButton
          name="choice6"
          value="Ne znam"
          inputId="unknown6"
          v-model="interestedInCreatingServices"
        />
        <label for="unknown6" class="label">Ne znam</label>
      </div>
    </div>

    <h4>
      16. U kom vremenskom periodu možete da se posvetite aktivnostima I MI
      Boke?
      <br />Možete izabrati više odgovora
    </h4>

    <div class="relative">
      <MultiSelect
        v-model="selectedActivities"
        display="chip"
        :options="activities"
        optionLabel="period"
        placeholder="Izaberite"
        :maxSelectedLabels="20"
        appendTo="body"
      />
    </div>

    <h4>17. Kako mislite da Vi možete doprinijeti radu I MI Boke?</h4>
    <div>
      <Textarea v-model="contributionToWork" autoResize rows="3" cols="47" />

      <h4>18. Koja su Vaša očekivanja od učlanjenja u I MI Boke?</h4>

      <Textarea v-model="expectations" autoResize rows="3" cols="47" />
    </div>

    <div class="button-container">
      <Button
        @click="sendDataToServer"
        class="sendAnswers"
        :loading="isSubmitting"
        :disabled="isSubmitting"
      >
        {{ isSubmitting ? 'Šaljem...' : 'Pošalji odgovore' }}
      </Button>
    </div>
  </div>
  <VolonterFinish v-if="finishVolonter" />
</template>

<script>
import VolonterFinish from "./VolonterFinish.vue";
import PhoneInput from "./PhoneInput.vue";
import LocationSelect from "./LocationSelect.vue";

export default {
  components: {
    VolonterFinish,
    PhoneInput,
    LocationSelect,
  },
  data() {
    return {
      firstAndLastName: "",
      dateOfBirth: null,
      cityPlaceOfBirth: "",
      dateFormat: "dd/mm/yy",
      countryPlaceOfBirth: "",
      streetAndNumber: "",
      postCode: "",
      cityAddressInfo: "",
      stateAddressInfo: "",
      mobilePhone: "",
      email: "",
      viber: "",
      homePhoneNumber: "",
      whatsapp: "",
      signal: "",
      telegram: "",
      facebook: "",
      educationalBackground: null,
      profession: "",
      workStatus: "",
      supportForOsi: "",
      foreignLanguages: "",
      foreignLanguagesNo: "",
      contributionToWork: "",
      expectations: "",
      genders: ["Muški", "Ženski", "Ne želim da kažem"],
      gender: null,
      finishVolonter: false,
      isSubmitting: false,
      educational: [
        "Bez škole",
        "Osnovna škola",
        "Srednja škola III stepen",
        "Srednja škola IV stepen",
        "Viša škola",
        "Visoka škola",
        "Master",
        "Doktor nauka",
      ],
      status: [
        "Angažovan/a bez ikakvog ugovora („na crno”)",
        "Angažovan/a po ugovoru o djelu",
        "Zaposlen/a na nepuno radno vrijeme",
        "Zaposlen/a na puno radno vrijeme, na određeno",
        "Zaposlen/a na puno radno vrijeme, na neodređeno",
        "Nezaposlen/a",
        "Na školovanju",
        "Dijete mlađe od školskog uzrasta",
        "Penzioner/ka",
      ],
      learnAboutOsi: null,
      supportForOsiQuestion: null,
      foreignLanguagesQuestion: null,
      computerDetailsFirstQuestion: null,
      computerDetailsSecondQuestion: null,
      interestedInCreatingServices: null,
      buttondisplay: null,
      selectedInterests: [],
      otherInterest: "", // tekst za opciju "Ostalo" u pitanju 14
      interests: [
        { period: "Radionicama u trajanju do dva sata" },
        { period: "Jednodnevnim seminarima/treninzima" },
        { period: "Seminarima/treninzima u trajanju od dva dana i više" },
        { period: "Višenedjeljnim obukama/kursevima" },
        {
          period:
            "Online vebinarima/predavanjima/kursevima (pohađaju se kad osobi najviše odgovara)",
        },
        {
          period:
            "Uživo i/ili online okruglim stolovima/konferencijama/javnim debatama",
        },
        { period: "Višednevnim putovanjima u zemlji" },
        { period: "Višednevnim putovanjima van zemlje" },
        { period: "Izletima" },
        { period: "Druženjima" },
        { period: "Sportskim aktivnostima i događajima" },
        { period: "Kulturnim aktivnostima i događajima" },
        { period: "Ostalo" },
      ],
      selectedActivities: [], // polje za čuvanje odabranih perioda
      activities: [
        // polje sa svim mogućim periodima
        { period: "Prije podne" },
        { period: "Poslije podne" },
        { period: "Tokom državnih praznika" },
        { period: "Vikendima" },
        { period: "Tokom godišnjeg odmora" },
        { period: "Bilo koji dan" },
        { period: "Ostalo" },
      ],
    };
  },
  computed: {
    hasOtherInterest() {
      return (this.selectedInterests || []).some((item) => item.period === "Ostalo");
    },
  },
  methods: {
    // [{ period }] — za "Ostalo" se upisani tekst šalje u value: { period: "Ostalo", value: "..." }
    interestsPayload() {
      return (this.selectedInterests || []).map((item) =>
        item.period === "Ostalo"
          ? { period: item.period, value: this.otherInterest.trim() || null }
          : { period: item.period }
      );
    },
    formatDateFull(datum) {
      if (!datum) return "";
      const d = new Date(datum);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    sendDataToServer() {
      const apiUrl = process.env.VUE_APP_API_URL;
      const formData = {
        firstAndLastName: this.firstAndLastName,
        gender: this.gender,
        dateOfBirth: this.formatDateFull(this.dateOfBirth),
        cityPlaceOfBirth: this.cityPlaceOfBirth,
        countryPlaceOfBirth: this.countryPlaceOfBirth,
        streetAndNumber: this.streetAndNumber,
        postCode: this.postCode,
        cityAddressInfo: this.cityAddressInfo,
        stateAddressInfo: this.stateAddressInfo,
        mobilePhone: this.mobilePhone,
        email: this.email,
        viber: this.viber,
        homePhoneNumber: this.homePhoneNumber,
        whatsapp: this.whatsapp,
        signal: this.signal,
        telegram: this.telegram,
        facebook: this.facebook,
        educationalBackground: this.educationalBackground,
        profession: this.profession,
        workStatus: this.workStatus,
        learnAboutOsi: this.learnAboutOsi,
        supportForOsiQuestion: this.supportForOsiQuestion,
        supportForOsi: this.supportForOsi,
        foreignLanguagesQuestion: this.foreignLanguagesQuestion,
        foreignLanguages: this.foreignLanguages,
        foreignLanguagesNo: this.foreignLanguagesNo,
        computerDetailsFirstQuestion: this.computerDetailsFirstQuestion,
        computerDetailsSecondQuestion: this.computerDetailsSecondQuestion,
        selectedInterests: this.interestsPayload(),
        interestedInCreatingServices: this.interestedInCreatingServices,
        selectedActivities: this.selectedActivities,
        contributionToWork: this.contributionToWork,
        expectations: this.expectations,
      };

      if (this.isSubmitting) return;
      this.isSubmitting = true;
      fetch(`${apiUrl}/volonter-part/save`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok: " + response.status);
          }
          return response.json();
        })
        .then(() => {
          this.finishVolonter = true;
          this.$toast.add({
            severity: "success",
            summary: "Uspješno",
            detail: "Vaša prijava je sačuvana.",
            life: 4000,
          });
        })
        .catch((error) => {
          console.error("Error sending data to server:", error);
          this.$toast.add({
            severity: "error",
            summary: "Greška pri slanju",
            detail: "Nismo uspjeli da sačuvamo Vaše podatke. Molimo Vas pokušajte ponovo za par trenutaka.",
            life: 6000,
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
